import React from 'react'
import PropTypes from 'prop-types'
import t from '../service/translate.service'

const NoContent = props => {
  const { message, image } = props
  return (
    <div className="no-content">
      <div className="message" role="alert" aria-live="assertive">{message}</div>
      <div className="image" role="img" aria-label={t.NOIMAGE}>
        {image}
      </div>
    </div>
  )
}

NoContent.propTypes = {
  message: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired

}
export default NoContent
